import { useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { DateInput } from 'atoms/date-input';
import Dropdown from 'atoms/dropdown';
import { convertDowIndex } from 'organisms/DrawerContent/Payment/RebookSlotSelector';
import { generateKey, getOpenHoursArray } from 'util';

dayjs.extend(customParseFormat);

export default function TimeSlotsSelector({
  groomer,
  luid,
  numberOfSlots = 1,
  selectedTimeSlots,
  setSelectedTimeSlots,
}) {
  const locations = useSelector((state) => state.provider.locations);
  const providerLocation = locations[0];
  const [dowsWithAvailability, setDowsWithAvailability] = useState([]);
  const [availability, setAvailability] = useState({});

  const loadDowAvailability = (date) => {
    const selectedDow = convertDowIndex(dayjs(date).day());
    const dowOpenDay = providerLocation?.hours.filter(
      (dowOpenHours) => dowOpenHours.dow.id === selectedDow
    )[0];

    if (!dowOpenDay) {
      setDowsWithAvailability([...dowsWithAvailability, selectedDow]);
      return;
    }

    const dowOpenTimes = dowOpenDay.time;
    if (!dowsWithAvailability.includes(selectedDow)) {
      const calendarPerDow = { [selectedDow]: getOpenHoursArray(dowOpenTimes) };
      setAvailability({ ...availability, ...calendarPerDow });
      setDowsWithAvailability([...dowsWithAvailability, selectedDow]);
    }
  };

  const getAvailabilityItems = (selectedDate) => {
    if (selectedDate === dayjs().format('YYYY-MM-DD')) {
      const dowAvailability =
        availability[convertDowIndex(dayjs(selectedDate).day())];
      const todayAvailability = dowAvailability.filter((time) =>
        dayjs(time, 'h:mma').isAfter(dayjs())
      );
      return todayAvailability ?? [];
    }
    return availability[convertDowIndex(dayjs(selectedDate).day())] ?? [];
  };

  const onChangeDateSelection = ({ position, dateSelected }) => {
    loadDowAvailability(dateSelected);
    setSelectedTimeSlots({
      ...selectedTimeSlots,
      [position]: { timeStart: '', date: dateSelected },
    });
  };

  const onSelectTime = ({ position, timeSelected }) => {
    const formattedTime = dayjs(timeSelected, 'h:mma').format('HH:mm:ss');
    setSelectedTimeSlots({
      ...selectedTimeSlots,
      [position]: {
        ...selectedTimeSlots[position],
        timeStart: [formattedTime],
      },
    });
  };

  if (!groomer || !luid || !numberOfSlots) return null;

  return (
    <>
      {[...Array(numberOfSlots)].map((slot, i) => (
        <div className="flex-row mb-15" key={generateKey}>
          <DateInput
            className="mr-15 w-100"
            placeholder="Date"
            onChange={(date) =>
              onChangeDateSelection({ position: i, dateSelected: date })
            }
            value={selectedTimeSlots[i].date || ''}
            minDate={dayjs()}
            size="large"
          />
          <Dropdown
            id={`time-${i}`}
            placeholder={
              availability[
                convertDowIndex(dayjs(selectedTimeSlots[i].date).day())
              ]
                ? 'Select time'
                : 'No times available'
            }
            className="w-100"
            items={getAvailabilityItems(selectedTimeSlots[i].date)}
            generateKey
            disableDropdown={
              !availability[
                convertDowIndex(dayjs(selectedTimeSlots[i].date).day())
              ]
            }
            onClick={(time) =>
              onSelectTime({ position: i, timeSelected: time })
            }
            value={
              selectedTimeSlots[i].timeStart?.[0]
                ? dayjs(selectedTimeSlots[i].timeStart?.[0], 'HH:mm:ss').format(
                    'h:mma'
                  )
                : ''
            }
          />
        </div>
      ))}
    </>
  );
}
